
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
import { Chip, FormFields, FilterFields, TableHeaderModel, SelectModel, MaestroProducto, CalendarioEvent } from '@/models/repsol-template.model';
import moment from 'moment';
import RepsolImportComponent from '@/components/repsol-import/RepsolImportComponent.vue';
import store from '@/store';
import { UserIdentityModel } from '@/models/file-entities.model';
import ComponentBase from '@/mixins/componentBase';
import { ImportLabels } from '@/models/repsol-template-aggregate.model';


class CalendarioPage extends ComponentBase {
  isOpenFilters = false;
  isOpenForm = false;
  formIsValid = true;
  formOnlyRead = false;
  isAdmin = false;

  isOpenImportar = false;

  deleteFilter = "";

  popupHeaderText = "";

  filterChips: Chip[] = [];

  formFields: FormFields[] = [];

  items: any[] = [];

  itemEdit: any = {};

  producto: MaestroProducto = { mercadoId: '', id: 0, nombre: '', soloLectura: true, horaCierreHabitual: '', diaCierreHabitual: 0, limiteInicial: 0, limiteSuperior: 0 };

  importExportYear: number[] = [];
  nowYear = 0;
  importUrl = "";

  configuracion: ImportLabels[] = [
    { label: 'calendario.total', campo: 'total', error: false, ocultarCeroVacio: true },
    { label: 'calendario.early_created', campo: 'Dias cierres tempranos creados', error: false, ocultarCeroVacio: true },
    { label: 'calendario.early_deleted', campo: 'Dias cierres tempranos eliminados', error: false, ocultarCeroVacio: true },
    { label: 'calendario.market_created', campo: 'Dias cierres mercado creados', error: false, ocultarCeroVacio: true },
    { label: 'calendario.market_deleted', campo: 'Dias cierres mercado eliminados', error: false, ocultarCeroVacio: true },
    { label: 'calendario.line_created', campo: 'Dias cierre de linea creados', error: false, ocultarCeroVacio: true },
    { label: 'calendario.line_deleted', campo: 'Dias cierre de linea eliminados', error: false, ocultarCeroVacio: true },
    { label: 'calendario.total_errors', campo: 'totalErrores', error: true, ocultarCeroVacio: true },
    {
      label: 'calendario.errors', campo: 'errores', error: true, ocultarCeroVacio: true, table: [
        { text: 'calendario.line', value: "linea", sortable: false },
        { text: 'calendario.type', value: "tipo", sortable: false },
        { text: 'calendario.error', value: "error", sortable: false },
      ]
    },
  ];

  @Watch('producto')
  changeProducto(): void {
    this.recargarCalendario();
  }

  @Watch('$i18n.locale')
  changeLocale(): void {
    this.setCalendarLabels();
    if (this.producto && this.producto.id && this.$refs.calendar) {
      this.selectedOpen = false;
      this.selectedEvent = {};
      this.recargarCalendario();
    }
  }

  constructor() {
    super();
    this.items = [];
  }

  mounted() {
    this.openSpinner("calendario.mostrarCalendario");

    const userIdentity = (store.state as any).userIdentity.userIdentity as UserIdentityModel;
    this.isAdmin = userIdentity.perfilId == 'ADM' || userIdentity.perfilId == 'CEN';
    this.producto.nombre = 'calendario.select_product';
    this.setCalendarLabels();
    this.getMaestroProducto().then(() => {
      this.producto = this.maestroProductoEscritura[0];
      if (this.producto && !this.producto.nombre) {
        this.producto.nombre = 'calendario.select_product';
      }
      //this.updateRange({ start: this.$refs.calendar.start, end: this.$refs.calendar.end });
      //this.$refs.calendar.checkChange();
    });

    this.nowYear = (new Date()).getFullYear();
    for (let year = -5; year < 2; year++) {
      if (year != 0)
        this.importExportYear.push(this.nowYear + year);
    }
  }

  setCalendarLabels(): void {
    this.typeToLabel = {
      month: this.tUi('calendario.month'),
      week: this.tUi('calendario.week'),
      day: this.tUi('calendario.day'),
      '4day': this.tUi('calendario.four_days'),
    };
    this.names = [
      this.tUi('calendario.sample_meeting'),
      this.tUi('calendario.sample_holiday'),
      this.tUi('calendario.sample_pto'),
      this.tUi('calendario.sample_travel'),
      this.tUi('calendario.sample_event'),
      this.tUi('calendario.sample_birthday'),
      this.tUi('calendario.sample_conference'),
      this.tUi('calendario.sample_party')
    ];
  }

  recargarCalendario() {
    console.log("recargar calendar ref", this.$refs.calendar);

    let start = new Date(this.$refs.calendar.lastStart ? this.$refs.calendar.lastStart.date : this.$refs.calendar.start);

    this.updateRange({ start: { year: start.getFullYear(), month: start.getMonth() + 1 } });
  }

  formEventAction(action: string, item: any): void {
    switch (action) {
      case 'salvar':
        if (item["$item_id"]) {
          // this.openSpinner("calendario.crearElemento");
          // Realizar la llamada a la API para crear el elemento
          this.post({ apiUrl: `/api/calendario/diaNoHabil`, entity: item })
            .then(() => {
              this.isOpenForm = false;
              this.closeSpinner();
              // this.mostrarOK("calendario.creacionExitosa");
            })
            .catch(() => {
              // Manejar errores si es necesario

              //this.mostrarKO("calendario.errorCreacion");
            });
        } else {
          // Crear
          // Aquí realizamos la llamada a la API para crear un nuevo elemento
          // this.openSpinner("calendario.crearElemento");
          this.post({ apiUrl: '/api/calendario/earlyClose', entity: item })
            .then(() => {
              // Mostrar mensaje de éxito
              this.isOpenForm = false;
              this.closeSpinner();
              // this.mostrarOK("calendario.creacionExitosa");
            })
            .catch(() => {
              // Manejar errores si es necesario
              //this.mostrarKO("calendario.errorCreacion");
            });
        }
        break;
      case 'cancelar':
        this.isOpenForm = false;
        break;
      case 'cambio':
        break;
      default:
        break;
    }
  }



  calendarioImportEventAction(action: string): void {
    this.recargarCalendario();
    this.isOpenImportar = false;
  }

  // Calendar

  focus = '';
  type = 'month';
  typeToLabel = {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    '4day': '4 Days',
  };
  selectedEvent: any = {};
  selectedElement = null;
  selectedOpen = false;
  confirmOpen = false;
  events: any[] = [];
  colors = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
  names = ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'];
  weekdays = [1, 2, 3, 4, 5, 6, 0];

  $refs!: {
    calendar: HTMLFormElement
  }

  viewDay({ nativeEvent, date }) {
    if (!this.isAdmin) return;
    const open = () => {
      this.selectedEvent = {
        tipo: 'crear',
        tipoCrear: 'early',
        name: this.tUi('calendario.new_event'),
        start: date,
        color: 'white',
        timed: false,
        details: ``
      };
      this.selectedElement = nativeEvent.target
      requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
    }
    open();
  }
  getEventColor(event) {
    return event.color
  }
  setToday() {
    this.focus = ''
  }
  prev() {
    this.$refs.calendar.prev()
  }
  next() {
    this.$refs.calendar.next()
  }
  showEvent({ nativeEvent, event }) {

    const open = () => {
      console.log("show event", event)
      this.selectedEvent = event
      this.selectedElement = nativeEvent.target
      requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
    }

    if (this.selectedOpen) {
      this.selectedOpen = false
      requestAnimationFrame(() => requestAnimationFrame(() => open()))
    } else {
      open()
    }

    nativeEvent.stopPropagation()
  }

  formatEventDetail(detail: string): string {
    const text = String(detail ?? '').trim();
    if (!text) {
      return '';
    }

    const translatedKey = this.tUi(text);
    if (translatedKey !== text) {
      return translatedKey;
    }

    const spanishPattern = /^(.*)\s+(compra|vende)\s+([\d.,]+)\s+lotes\/unidades\s+para\s+(.+)$/i;
    const englishPattern = /^(.*)\s+(buys|sells)\s+([\d.,]+)\s+lots\/units\s+for\s+(.+)$/i;

    const spanishMatch = text.match(spanishPattern);
    if (spanishMatch) {
      const [, desk, action, quantity, month] = spanishMatch;
      const actionKey = action.toLowerCase() === 'compra'
        ? 'calendario.operation_action_buy'
        : 'calendario.operation_action_sell';

      return this.$t('calendario.operation_detail', {
        desk: desk.trim(),
        action: this.$t(actionKey).toString(),
        quantity,
        month: month.trim(),
      }).toString();
    }

    const englishMatch = text.match(englishPattern);
    if (englishMatch) {
      const [, desk, action, quantity, month] = englishMatch;
      const actionKey = action.toLowerCase() === 'buys'
        ? 'calendario.operation_action_buy'
        : 'calendario.operation_action_sell';

      return this.$t('calendario.operation_detail', {
        desk: desk.trim(),
        action: this.$t(actionKey).toString(),
        quantity,
        month: month.trim(),
      }).toString();
    }

    return text;
  }

  updateRange({ start }) {
    this.closeSpinner();

    console.log('updateRange', start.month, start.year, this.producto);
    this.events.splice(0);
    if (!this.producto.id) {
      console.error('Datos de inicio inválidos:', start);
      return;
    }

    // const dateTimeString = start.time ? `${start.date} ${start.time}` : start.date;
    //const min = new Date(start.date);

    //post getall
    const evento = { mercadoId: this.producto.mercadoId, productoId: this.producto.id, mes: start.month, anio: start.year };

    this.openSpinner("calendario.mostrarCalendario");
    this.post({ apiUrl: '/api/calendario/list', entity: evento })
      .then((data) => {
        console.log('Listado eventos OK', data);
        // Mostrar mensaje de éxito
        this.isOpenForm = false;
        this.closeSpinner();
        
        const eventos = Array.isArray(data) ? data : data?.items ?? [];
        this.events = eventos;

        this.events.forEach(e => {
          e.start = new Date(e.start);
          e.timed = false;
          switch (e.tipo) {
            case "early":
                e.name = e.time + " " + this.tUi('calendario.early_close')
              e.color = "indigo"
                e.details = [this.tUi('calendario.early_close_detail')]
              break;

            case "cerrado":
                e.name = this.tUi('calendario.closed_event')
              e.color = "red"
                e.details = [this.tUi('calendario.closed_detail')]
              break;

            case "operacion":
                e.name = this.tUi('calendario.loaded')
              e.color = "green"
              break;

            case "linea":
                e.name = this.tUi('calendario.line_start')
              e.color = "cyan"
                e.details = [this.tUi('calendario.line_start_detail')]
              break;
          }
        })
        //this.$refs.calendar.checkChange();
      })
      .catch(() => {
        // Manejar errores si es necesario
        console.log('Listado eventos KO!!');
        this.mostrarKO("calendario.errorCreacion");
        this.closeSpinner();
      });
  }
  rnd(a, b) {
    return Math.floor((b - a + 1) * Math.random()) + a
  }

  eventoPopup(evento: string) {
    switch (evento) {
      case 'eliminar':
        this.eliminarEvento();
        break;
      case 'navegar':
        this.$router.push({
          path: ((this.selectedEvent.start as Date) < new Date()) ? '/Operaciones/Presentes_futuras' : '/Operaciones/Historico', query: {
            'q-fechaDesde': moment(this.selectedEvent.start).format("YYYY-MM-DD"),
            'q-fechaHasta': moment(this.selectedEvent.start).add(1, 'days').format("YYYY-MM-DD")
          }
        });
        break;
      case 'crear': {
        const eventoCrear = { mercadoId: this.producto.mercadoId, dia: this.selectedEvent.start };
        const eventoCrearEarly = { productoId: this.producto.id, horaCierre: this.selectedEvent.start + " " + this.selectedEvent.time };
        const eventoCierreLinea = { productoId: this.producto.id, dia: this.selectedEvent.start }
        let apiUrl;

        if (this.selectedEvent.tipoCrear === 'cerrado') {
          apiUrl = '/api/calendario/diaNoHabil';
          this.crearEvento(apiUrl, eventoCrear);
        } else if (this.selectedEvent.tipoCrear === 'early') {
          const earlyUrl = '/api/calendario/earlyClose';
          apiUrl = earlyUrl;
          this.crearEvento(apiUrl, eventoCrearEarly);
        } else {
          const lineaUrl = '/api/calendario/diaCierreLinea';
          apiUrl = lineaUrl;
          this.crearEvento(apiUrl, eventoCierreLinea)

        }
        break;
      }

      default:
        break;
    }
    this.selectedOpen = false;
  }

  eliminarEvento() {
    let apiUrl;
    switch (this.selectedEvent.tipo) {
      case 'cerrado':
        apiUrl = '/api/diaNoHabil';
        break;

      case 'early':
        apiUrl = '/api/earlyClose';
        break;

      case 'linea':
        apiUrl = '/api/diaCierreLinea';
        break;

      default:
        // Manejar el caso por defecto o lanzar un error si es inesperado.
        break;
    }

    this.openSpinner("calendario.eliminarExitosa");
    this.delete({ apiUrl: apiUrl, entity: this.selectedEvent })
      .then(() => {
        this.closeSpinner();
        this.mostrarOK("calendario.eliminarExitosa");
        // Actualizar el calendario después de la eliminación
        this.recargarCalendario();
      })
      .catch(() => {
        this.closeSpinner();
        this.mostrarKO("calendario.errorEliminar");
      });
  }

  // Función para manejar la lógica común de creación de eventos
  crearEvento(apiUrl, eventoCrear) {
    this.openSpinner("calendario.crearElemento");
    this.post({ apiUrl, entity: eventoCrear })
      .then(() => {
        // Mostrar mensaje de éxito
        this.isOpenForm = false;
        this.closeSpinner();
        this.mostrarOK("calendario.creacionExitosa");
        this.recargarCalendario();
      })
      .catch(() => {
        // Manejar errores si es necesario
        this.mostrarKO("calendario.errorCreacion");
        this.closeSpinner();
      });
  }

  // Calendar
  async descargar(anio: number) {
    const route = `/api/calendario/Export?anio=${anio}&productoId=${this.producto.id}&localized=true`;

    this.post({ apiUrl: route, entity: {}, array: true }).then(data => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', 'table.xlsx');

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    })
  }

  importarCalendario(anio: number): void {
    this.importUrl = `/api/calendario/Import?anio=${anio}&productoId=${this.producto.id}`;
    this.isOpenImportar = true;
  }
}

export default Component({
  name: 'CalendarioPage',
  components: {
    RepsolFilterBarComponent,
    RepsolFilterChipsComponent,
    RepsolTableComponent,
    RepsolFormPopupComponent,
    RepsolImportComponent
  },
})(CalendarioPage);
